export const moduleId = 'departrment';
export const state = {
  deparDialog: false


};
export const actions = {



};
export const mutations = {
      setDeparDialog(state,falg){
        state.deparDialog = falg
      }


}

export const getters = {}




// WEBPACK FOOTER //
// ./src/store/modules/account-management/departrment/index.js